<script lang="ts">
  import clsx from 'clsx';
  import type { StackDividers } from './types';

  const { dividers }: { dividers: StackDividers | undefined } = $props();
</script>

<div
  class={clsx(
    dividers === 'strong' && 'border-st-gray-900',
    dividers === 'default' && 'border-st-gray-300',
    'w-full max-w-full self-stretch border-t border-solid',
  )}
></div>
